import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import ReactJson from 'react-json-view';
import { Button } from '@mui/material';
import { checkBannerFpEngineConfig } from '../../../../utilities/bannerFpEngineConfigCheck';
import { useNavigate } from 'react-router-dom';
import {
	ALL_ENGINE_MODELS,
	ALL_SERVICES,
	CONFIG_STRUCTURE_KEYS,
	SERVICE_CONFIG_KEYS,
	MANUAL_FLOOR_KEYS,
	OPERATION_MODES
} from '../../constants';
import useStyles from './styles';
import { Box } from '@mui/system';
import { toast } from 'react-toastify';
import {
	createBannerFpConfig,
	updateBannerFpConfigInDb,
	syncManualFloors
} from '../../../../api/bannerFpEngine';
import { BANNER_FP_EDIT_MODES } from '../../../../core/constants';

const FinalOverview = () => {
	const { bannerFpConfig, bannerFpConfigEditMode, previousFpCouchBaseConfig } =
		useContext(BannerFpContext);
	const classes = useStyles();
	const navigate = useNavigate();
	const handleUpdateDoc = async () => {
		try {
			checkBannerFpEngineConfig({
				bannerFpConfig,
				ALL_ENGINE_MODELS,
				ALL_SERVICES,
				CONFIG_STRUCTURE_KEYS,
				SERVICE_CONFIG_KEYS,
				MANUAL_FLOOR_KEYS
			});

			const { siteId, siteDomain } = bannerFpConfig;
			const dataObject = {
				data: bannerFpConfig,
				previousCouchBaseConfig: previousFpCouchBaseConfig.current,
				mode: bannerFpConfigEditMode,
				siteId,
				siteDomain
			};
			if (bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.CREATE) {
				await createBannerFpConfig(dataObject);
				toast.success('Banner Fp Config sucessfully created!', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
				navigate(`/banner-fp/update-config/${bannerFpConfig.siteId}`);
			}
			if (bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.UPDATE) {
				await updateBannerFpConfigInDb(dataObject);
				toast.success('Banner Fp Config sucessfully Updated!', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
			}
			previousFpCouchBaseConfig.current = bannerFpConfig;
		} catch (err) {
			const errMessage = err?.response?.data?.data?.message || err.message;
			toast.error(errMessage || 'Some Error Occured in Updating Doc', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			console.log(err);
		}
	};

	const handleManualFloorsSync = async () => {
		toast.success('Floors sent for Syncing', {
			position: toast.POSITION.BOTTOM_RIGHT
		});
		try {
			const { siteId, siteDomain } = bannerFpConfig;
			const mode = OPERATION_MODES.SYNC_FP_MANUAL_FLOORS;
			const dataObject = {
				data: bannerFpConfig,
				previousCouchBaseConfig: bannerFpConfig,
				mode,
				siteId,
				siteDomain
			};
			const data = await syncManualFloors(dataObject);
			toast.success(data?.data?.message || 'Sync success', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		} catch (err) {
			const errMessage = err?.response?.data?.data?.message || err.message;
			toast.error(errMessage || 'Some Error Occured', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};
	return (
		<Box
			style={{
				position: 'absolute',
				bottom: '6rem',
				right: '50%',
				transform: 'translate(50%,50%)',
				width: '40rem',
				display: 'flex',
				justifyContent: 'space-between'
			}}
		>
			<Button variant="contained" onClick={handleUpdateDoc}>
				{bannerFpConfigEditMode} Doc
			</Button>

			<Button variant="contained" onClick={handleManualFloorsSync}>
				Sync Manual Floors
			</Button>

			<Box className={classes.finalOverview}>
				<ReactJson
					enableClipboard={true}
					displayDataTypes={false}
					src={bannerFpConfig}
					name={null}
				/>
			</Box>
		</Box>
	);
};

export default FinalOverview;
